// extracted by mini-css-extract-plugin
export default {"ifc-viewer":"IB6pSTMlJ8hrJk_OGsFq","ifcViewer":"IB6pSTMlJ8hrJk_OGsFq"};